import JourneyDetailsWithABSADS from './JourneyDetailsWithABSADS';

export default JourneyDetailsWithABSADS;
